export const APPOINTMENT_STATUS_CLEAR = 'APPOINTMENT_STATUS_CLEAR';


// WEBPACK FOOTER //
// ./app/constants/appointmentStatusTypes.js